import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tab_right",
  "use": "icon-tab_right-usage",
  "viewBox": "0 0 14 48",
  "content": "<symbol viewBox=\"0 0 14 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tab_right\">\n<path d=\"M0 0C2.54893 0 3.8234 0 4.86805 0.404117C6.20305 0.920556 7.30944 1.89726 7.98747 3.15789C8.51804 4.14435 8.67612 5.40897 8.99228 7.93822L14 48H0V0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol